import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import queryString from 'query-string';
import { Button } from '@deeptrue-frontend/ui';

import { useFormatMessage } from 'components/IntlProvider';
import { Dashboard } from 'components/Layout';
import api from 'api/api';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { WorkbenchesReducerType } from 'store/modules/workbenches/workbenches.types';
import Workbenches from 'components/Workbenches/Workbenches';
import EmptyPlaceholder from 'components/EmptyPlaceholder/EmptyPlaceholder';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import AdminMenu from 'components/AdminMenu/AdminMenu';

const { ROUTES } = RouterProvider;
const { connect, selectors, actions } = StoreProvider;

interface WorkbenchesListProps extends RouteComponentProps {
  workbenches: WorkbenchesReducerType['list'];
  setWorkbenches: (payload: WorkbenchesReducerType['list']) => void;
}

const WorkbenchesList = ({
  workbenches,
  setWorkbenches,
  location,
  history,
}: WorkbenchesListProps) => {
  const t = useFormatMessage();
  const [isLoaded, setIsLoaded] = useState(false);

  const parsedSearch = queryString.parse(location.search);

  const refreshWorkbenches = () => {
    setIsLoaded(false);
    api.resources
      .getWorkbenches(
        parsedSearch as {
          limit: string;
          offset: string;
          search: string;
        }
      )
      .then(({ data }) => {
        setWorkbenches(data);
      })
      .finally(() => {
        setIsLoaded(true);
      });
  };

  useEffect(() => {
    refreshWorkbenches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const getPageNumber = () => {
    if (parsedSearch.offset && !Array.isArray(parsedSearch.offset)) {
      return parseInt(parsedSearch.offset, 10) / 20 + 1;
    }

    return 0;
  };

  return (
    <Dashboard title="Workbenches" location={location}>
      <AdminMenu />

      <Button
        color="primary"
        mb="2rem"
        onClick={() => history.push(ROUTES.ADMIN.WORKBENCHES.CREATE)}
      >
        {t('dashboard.workbenches.new', 'New Workbench')}
      </Button>
      <EmptyPlaceholder
        isLoaded={isLoaded}
        hasValues={workbenches.results.length > 0}
        withLoader
      >
        <Workbenches
          list={workbenches.results}
          count={workbenches.count}
          currentPage={getPageNumber()}
          refresh={refreshWorkbenches}
        />
      </EmptyPlaceholder>
    </Dashboard>
  );
};

export default connect(
  (state) => ({
    workbenches: selectors.workbenches.list(state),
  }),
  {
    setWorkbenches: actions.workbenches.setWorkbenches,
  }
)(WorkbenchesList);
